<div *ngIf="dataset" class="tree-node-grid">
  <div class="cell cell-name">
    <div class="icon-container">
      <ix-dataset-icon [dataset]="dataset"></ix-dataset-icon>
    </div>
    <span class="name" [matTooltip]="label">
      {{ label }}
    </span>
  </div>
  <div class="cell cell-used">
    <div class="cell-used-content">
      <span>{{ dataset.used.parsed | filesize: { standard: 'iec', round: 2 } }}</span>
      /
      <span>{{ dataset.available.parsed | filesize: { standard: 'iec', round: 2 } }}</span>
    </div>
  </div>
  <div class="cell cell-encryption">
    <ix-dataset-encryption-cell
      [dataset]="dataset"
    ></ix-dataset-encryption-cell>
  </div>
  <div class="cell cell-roles">
    <ix-dataset-roles-cell
      [dataset]="dataset"
      [isSystemDataset]="isSystemDataset"
    ></ix-dataset-roles-cell>
  </div>
</div>
